import React from 'react';
import { AlertTriangle, Check } from 'react-feather';
import RetryButton from 'components/Practice/shared/RetryButton';
import SkippedDisabledButtons from 'components/Practice/Recording/SkippedDisabledButtons';
import Skipped from 'components/VideoResponse/Learning/Response/Skipped';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const SkippedSuccess = ({
  disabled,
  showTechnicalDifficulties,
  finished,
  reloadRecording,
  mediaButtonClass,
  disabledMediaButtonClass,
  recordButtonText,
  uploadButtonText,
  ...props
}) => {
  if (showTechnicalDifficulties) {
    return !finished ? (
      <>
        <SkippedDisabledButtons
          mediaButtonClass={mediaButtonClass}
          disabledMediaButtonClass={disabledMediaButtonClass}
          recordButtonText={recordButtonText}
          uploadButtonText={uploadButtonText}
        />
        <div className="d-f fd-c ai-c">
          <div className="d-f fd-r lh-20 pt-16 as-fs">
            <Check size="2rem" className="mr-4 c-success" />
            <div className="d-f fw-w">
              <Text
                className="d-f ai-c c-success mr-4"
                variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
              >
                {t(
                  'practice.on_demand_practice.audio_recording.skip_recording.success.success_message',
                )}
              </Text>
              <RetryButton onClick={reloadRecording} />
            </div>
          </div>
        </div>
      </>
    ) : (
      <div className="Response-skippedMessage d-f ai-c">
        <AlertTriangle size={16} className="mr-8 fs-0" />
        <Text variant={TEXT_VARIANTS.BODY}>
          {props.i18n.video_response.skipped.finished.learner}{' '}
          {props.i18n.video_response.skipped.finished.notified}
        </Text>
      </div>
    );
  }

  return (
    <div className="fz-bigger">
      <Skipped {...props} finished={finished} />
      {!disabled && <RetryButton onClick={reloadRecording} />}
    </div>
  );
};

export default SkippedSuccess;
